interface IconProps {
  color?: string
  className?: string
}

export default function MarketTabIcon({ color, className }: IconProps) {
  return (
    <svg
      viewBox="0 0 1117 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M167.75 102.214h787.363a40.495 40.495 0 0 0 40.308-40.402v-20.2a40.495 40.495 0 0 0-40.308-40.309H167.75a40.495 40.495 0 0 0-40.309 40.309v20.2c0 22.25 18.153 40.402 40.309 40.402z m948.875 323.025l-101.003-282.624H107.148L6.238 425.24H2.14C0.186 431.29 0.186 439.39 0.186 445.44c0 56.506 58.554 100.91 131.258 100.91 72.611 0 131.259-44.404 131.259-100.91 0-6.05 0-14.15-2.048-20.2h26.251c-2.048 6.05-2.048 14.15-2.048 20.2 0 56.506 58.554 100.91 131.258 100.91 72.611 0 131.259-44.404 131.259-100.91 0-6.05 0-14.15-2.048-20.2h26.251c-2.048 6.05-2.048 14.15-2.048 20.2 0 56.506 58.554 100.91 131.258 100.91 72.611 0 131.259-44.404 131.259-100.91 0-6.05 0-14.15-2.048-20.2h26.251c-2.048 6.05-2.048 14.15-2.048 20.2 0 56.506 58.647 100.91 131.258 100.91 72.611 0 131.259-44.404 131.259-100.91 0-6.05 0-14.15-2.048-20.2h1.861zM936.774 841.821H200.797V586.752H96.163v403.735h948.876V586.752H936.774v255.07z"
        fill={color ?? '#ffffff'}
      />
    </svg>
  )
}
